"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.concat");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = usePropHook;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

function usePropHook(propHook) {
  var _ref = Array.isArray(propHook) ? propHook : [propHook],
      _ref2 = (0, _slicedToArray2.default)(_ref, 2),
      hook = _ref2[0],
      _ref2$ = _ref2[1],
      args = _ref2$ === void 0 ? [] : _ref2$;

  for (var _len = arguments.length, otherArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    otherArgs[_key - 1] = arguments[_key];
  }

  return hook.apply(void 0, [].concat((0, _toConsumableArray2.default)(args), otherArgs));
}